/* eslint-disable */
export default {
  forward: 'Inoltra',
  cancel: 'Annulla',
  customNumber: 'Numero personalizzato',
} as const;

// @key: @#@"forward"@#@ @source: @#@"Forward"@#@
// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"customNumber"@#@ @source: @#@"Custom number"@#@
